import getCookie from './getCookie';

export default function cookieIsSet(name) {
  return getCookie(name) !== '';
}
